import styled from "styled-components";

export const HomePurchaseListWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  /* background-color: white; */

  @media (max-width: 768px) {
    width: 100%;
  }
`;
